import React, { Component } from 'react';
import { getRequestParams } from '../../helpers/globalfunctions';
import { VehiclePayReportPayrollPeriodwise } from '../Report/VehiclePayReportPayrollPeriodwise'
import { IATAInvoiceReportComponent } from '../Report/IATAInvoiceReportComponent'
import { WorkCompensationReportComponent } from '../Report/WorkCompensationReportComponent'
import { RideCommissionDetailsReportComponent } from '../Report/RideCommissionDetailsReportComponent'
import { DriverLoginHistoryReportComponent } from '../Report/DriverLoginHistoryReportComponent'
import { MonthlyBudgetComparisonReportComponent } from '../Report/MonthlyBudgetComparisonReportComponent'
import { CongestionReportComponent } from '../Report/CongestionReportComponent'
import { SalesActivityComponent } from '../Report/SalesActivityComponent'
import { VehiclePayReportSummaryDetailsComponent } from '../Report/VehiclePayReportSummaryDetailsComponent'
import { InvoiceReportComponent } from '../Report/InvoiceReportComponent'
import { InvoiceSummaryReportPickupwiseComponent } from '../Report/InvoiceSummaryReportPickupwiseComponent'
import { InvoiceSummaryGraphComponent } from '../Report/InvoiceSummaryGraphComponent'
import { DriverWorkHourHistoryReportComponent } from '../Report/DriverWorkHourHistoryReportComponent'
import { CustomerRideActivityReportComponent } from '../Report/CustomerRideActivityReportComponent';
import { RevenueProfitLossComponent } from '../Report/RevenueProfitLossComponent';
import { RevenueYearlyComparisonComponent } from '../Report/RevenueYearlyComparisonComponent';
import { GTOnTimePerformanceComponent } from '../Report/GTOnTimePerformanceComponent';
import { AirlineScorecardReportComponent } from '../Report/AirlineScorecardReportComponent'
import { AirlineRideActivityReportComponent } from './AirlineRideActivityReportComponent';
import { VehiclesProductivityReportComponent } from './VehiclesProductivityReportComponent';
import { CompletedJobsComparisonReportComponent } from '../Report/CompletedJobsComparisonReportComponent'
import { CumulativeSalesReportComponent } from '../Report/CumulativeSalesReportComponent'
import { ReservationAgentProductivityReportComponent } from '../Report/ReservationAgentProductivityReportComponent'
import { VehicleReimbursmentSummaryComponent } from '../Report/VehicleReimbursmentSummaryComponent'
import { VehicleLoanAccountLedgerComponent } from '../Report/VehicleLoanAccountLedgerComponent'
import { VehicleLoanReportComponent } from '../Report/VehicleLoanReportComponent'
import { AgentCommissionReportComponent } from '../Report/AgentCommissionReportComponent'
import { AuditReportComponent } from '../Report/AuditReportComponent'
import { BillingReconsilationReportComponent } from '../Report/BillingReconsilationReportComponent'
import { VehicleCommissionReportComponent } from '../Report/VehicleCommissionReportComponent'
import { VehicleDeductionReportComponent } from '../Report/VehicleDeductionReportComponent'
import { VehicleDepositDetailsReportComponent } from '../Report/VehicleDepositDetailsReportComponent'
import { VehicleReimbursmentAddOnsReportComponent } from '../Report/VehicleReimbursmentAddOnsReportComponent'
import { VehicleReimbDeductionHistoryReportComponent } from '../Report/VehicleReimbDeductionHistoryReportComponent'
import { VehicleReimbReceivableReportComponent } from '../Report/VehicleReimbReceivableReportComponent'
import { VehicleReimbRevenueReportComponent } from '../Report/VehicleReimbRevenueReportComponent'
import { FranchiseeDescripancyReportComponent } from '../Report/FranchiseeDescripancyReportComponent'
import { CustomerInvoiceSummaryReportComponent } from '../Report/CustomerInvoiceSummaryReportComponent'
import { AccountPaymentsReportComponent } from '../Report/AccountPaymentsReportComponent'
import { RevenueSummaryGraphReportComponent } from '../Report/RevenueSummaryGraphReportComponent'
import { RideCommissionCashCCReportComponent } from '../Report/RideCommissionCashCCReportComponent'
import { DataEntryAuditReportComponent } from '../Report/DataEntryAuditReportComponent'
import { NoShowReservationReportComponent } from '../Report/NoShowReservationReportComponent'
import { VehiclePayrollExceptionsComponent } from '../Report/VehiclePayrollExceptionsComponent'
import { TaxComponent } from '../Report/TaxComponent'
import { AccountRideDetailsReportOnlyComponent } from '../Report/AccountRideDetailsReportOnlyComponent'
import { RideListingRevenueReportComponent } from '../Report/RideListingRevenueReportComponent'
import { MeetAndGreetReportComponent } from '../Report/MeetAndGreetReportComponent'
import { EstimateReimbursementReportComponent } from '../Report/EstimateReimbursementReportComponent'
import { AccountSummaryPaymentTypeWiseComponent } from '../Report/AccountSummaryPaymentTypeWiseComponent'
import { RideReconsilationReportComponent } from '../Report/RideReconsilationReportComponent'
import { InvoiceDueSummaryReportComponent } from '../Report/InvoiceDueSummaryReportComponent'
import { RidesApprovedReportComponent } from '../Report/RidesApprovedReportComponent'
import { RidesBilledReportComponent } from '../Report/RidesBilledReportComponent'
import { RidesUnApprovedReportComponent } from '../Report/RidesUnApprovedReportComponent'
import { CustomerCommissionRideReportComponent } from '../Report/CustomerCommissionRideReportComponent'
import { RideListingCashCCReportComponent } from '../Report/RideListingCashCCReportComponent'
import { DispatchComponent } from '../Report/DispatchComponent'
import { RatesComponent } from '../Report/RatesComponent'
import { DriverCommissionComponent } from '../Report/DriverCommissionComponent'
import { DriverPaidReportComponent } from '../Report/DriverPaidReportComponent'
import { DeferredRevenueReportComponent } from '../Report/DeferredRevenueReportComponent'
import { CreditcardHistoryReportComponent } from '../Report/CreditcardHistoryReportComponent'
import { OpenReservationsReportComponent } from '../Report/OpenReservationsReportComponent'
import { CancelledReservationsReportComponent } from '../Report/CancelledReservationsReportComponent'
import { ClosedReservationsReportComponent } from '../Report/ClosedReservationsReportComponent'
import { DeductionsComponent } from '../Report/DeductionsComponent'
import { VehicleJobHistoryReportComponent } from '../Report/VehicleJobHistoryReportComponent'
import { AccountRidePaxReportComponent } from '../Report/AccountRidePaxReportComponent'
import { DailyJobCountComponent } from '../Report/DailyJobCountComponent'
import { RidesCloseoutReportComponent } from '../Report/RidesCloseoutReportComponent'
import { ARPreviewInvoiceReportComponent } from '../Report/ARPreviewInvoiceReportComponent'
import { BillingCharterInvoiceReportComponent } from '../Report/BillingCharterInvoiceReportComponent'
import { InvoicePaidReportCompnent } from '../Report/InvoicePaidReportCompnent'
import { DriverDutyReportCompnent } from '../Report/DriverDutyReportCompnent'


// Maps normalized report name → route pathname (for history.push reports)
const REPORT_ROUTES = {
    CHARTERINVOICEREPORTBASEFARE: '/reports/charterinvoicereport',
    INVOICERECEIPTVOUCHER: '/reports/invoicereceiptvoucher',
    DISPATCHERLOGINWISEPRODUCTIVITY: '/reports/dispatcherproductivity',
    VEHICLETRIPFARESUMMARY: '/reports/vehicletripfare-summary',
    RESERVATIONAGENTLOGINWISEPRODUCTIVITY: '/reports/reservationagentproductivity',
    INVOICESALES: '/reports/invoicesales',
    WEEKLYREVENUEREPORT: '/reports/weeklyrevenue-summary',
    ACCOUNTRIDEDETAILS: '/reports/account-ride-details',
    DRIVELOGINWISERIDESUMMARY: '/reports/driver-loginwise-ride-summary',
    DRIVERLOGINWISERIDESUMMARY: '/reports/driver-loginwise-ride-summary',
    RIDESTATUSWISESUMMARY: '/reports/statuswise-ride-summary',
    TRACKLOG: '/reports/tracklog',
    RIDEDETAILSHOURLY: '/reports/hourly-ride-report',
};

// Maps normalized report name → [refName, optional showModal arg]
const REPORT_REF_ACTIONS = {
    ACCOUNTSUMMARYPAYMENTTYPEWISE:          ['accountSummaryPaymentTypeWiseComponent'],
    CUSTOMERCOMMISSION:                     ['customerCommissionRideReportComponent'],
    INVOICEDUESUMMARY306090DAYS:            ['invoiceDueSummaryReportComponent'],
    VEHICLEPAYREPORTPAYROLLPERIODWISE:      ['vehiclePayReportPayrollPeriodwise'],
    VEHICLEPAYREPORTSUMMARYDETAILS:         ['vehiclePayReportSummaryDetailsComponent'],
    RIDERECONSILATIONSTATEMENT:             ['rideReconsilationReportComponent'],
    RIDESAPPROVED:                          ['ridesApprovedReportComponent'],
    SALESACTIVITY:                          ['salesActivityComponent'],
    INVOICEREPORT:                          ['invoiceReportComponent'],
    IATAREPORT:                             ['iataInvoiceReportComponent'],
    WORKCOMPENSATIONREPORT:                 ['workCompensationReportComponent'],
    RIDECOMMISSIONDETAILS:                  ['rideCommissionDetailsReportComponent'],
    RIDESUNAPPROVED:                        ['ridesUnApprovedReportComponent'],
    RIDESBILLED:                            ['ridesBilledReportComponent'],
    CONGESTIONREPORT:                       ['congestionReportComponent'],
    DRIVERLOGINHISTORY:                     ['driverLoginHistoryReportComponent'],
    INVOICESUMMARYREPORTPICKUPWISE:         ['invoiceSummaryReportPickupwiseComponent'],
    INVOICESUMMARYGRAPH:                    ['invoiceSummaryGraphComponent'],
    MONTHLYBUDGETCOMPARISON:                ['monthlyBudgetComparisonReportComponent'],
    DRIVERWORKHOURSHISTORY:                 ['driverWorkHourHistoryReportComponent'],
    CUSTOMERRIDEACTIVITYLOG:                ['customerRideActivityReportComponent'],
    REVENUEPROFITLOSS:                      ['revenueProfitLossComponent'],
    REVENUEYEARLYCOMPARISON:                ['revenueYearlyComparisonComponent'],
    GTONTIMEPERFORMANCE:                    ['gTOnTimePerformanceComponent'],
    COMPLETEDJOBSCOMPARISON:                ['completedJobsComparisonReportComponent'],
    CUMULATIVESALESREPORT:                  ['cumulativeSalesReportComponent'],
    AIRLINESCORECARD:                       ['airlineScorecardReportComponent'],
    AIRLINERIDEACTIVITY:                    ['airlineRideActivityReportComponent'],
    VEHICLEPRODUCTIVITY:                    ['vehiclesProductivityReportComponent'],
    VEHICLEREIMBURSEMENTSUMMARY:            ['vehicleReimbursmentSummaryComponent', 1],
    VEHICLEREIMBURSEMENTSUMMARYREPORT:      ['vehicleReimbursmentSummaryComponent', 2],
    VEHICLEREIMBURSEMENTUFBALANCEREPORT:    ['vehicleReimbursmentSummaryComponent', 3],
    AGENTCOMMISSION:                        ['agentCommissionReportComponent'],
    AUDITREPORT:                            ['auditReportComponent'],
    VEHICLEPAYREGISTER:                     ['auditReportComponent'],
    BILLINGRECONSILATIONREPORT:             ['billingReconsilationReportComponent'],
    VEHICLECOMMISSION:                      ['vehicleCommissionReportComponent'],
    VEHICLEDEDUCTIONREPORT:                 ['vehicleDeductionReportComponent'],
    VEHICLEDEPOSITDETAILS:                  ['vehicleDepositDetailsReportComponent'],
    VEHICLELOANACLEDGER:                    ['vehicleLoanAccountLedgerComponent'],
    VEHICLELOANREPORT:                      ['vehicleLoanReportComponent'],
    VEHICLEREIMBURSEMENTADDONS:             ['vehicleReimbursmentAddOnsReportComponent'],
    VEHICLEREIMBURSEMENTDEDUCTIONHISTORY:   ['vehicleReimbDeductionHistoryReportComponent'],
    VEHICLEREIMBURSEMENTRECEIVABLE:         ['vehicleReimbReceivableReportComponent'],
    VEHICLEREIMBURSEMENTREVENUE:            ['vehicleReimbRevenueReportComponent'],
    FRDESCRIPANCYREPORT:                    ['franchiseeDescripancyReportComponent'],
    CUSTOMERINVOICESUMMARY:                 ['customerInvoiceSummaryReportComponent'],
    PAYMENTS:                               ['accountPaymentsReportComponent'],
    REVENUESUMMARYGRAPH:                    ['revenueSummaryGraphReportComponent'],
    DATAENTRYAUDITREPORT:                   ['dataEntryAuditReportComponent'],
    ACCOUNTRIDEDETAILSREPORTONLY:           ['accountRideDetailsReportOnlyComponent'],
    RIDELISTINGREVENUE:                     ['rideListingRevenueReportComponent'],
    VEHICLEPAYROLLEXCEPTIONS:               ['vehiclePayrollExceptionsComponent'],
    TAX:                                    ['taxComponent'],
    RIDECOMMISSIONCASHCC:                   ['rideCommissionCashCCReportComponent'],
    NOSHOWRESERVATION:                      ['noShowReservationReportComponent'],
    RIDELISTINGCASHCC:                      ['rideListingCashCCReportComponent'],
    RIDESTOBEDISPATCHED:                    ['dispatchComponent', '1'],
    RIDESDISPATCHED:                        ['dispatchComponent', '2'],
    SCHEDULEDRIDESNEXT8HOURS:               ['dispatchComponent', '3'],
    SCHEDULEDRIDESBEYOND8HOURS:             ['dispatchComponent', '4'],
    MEETANDGREETRIDES:                      ['meetAndGreetReportComponent'],
    ESTIMATEREIMBURSEMENT:                  ['estimateReimbursementReportComponent'],
    DRIVERPAID:                             ['driverPaidReportComponent'],
    ZONALRATES:                             ['ratesComponent', '1'],
    HOURSRATES:                             ['ratesComponent', '2'],
    DRIVERCOMMISSION:                       ['driverCommissionComponent'],
    DEFFEREDREVENUEREPORT:                  ['deferredRevenueReportComponent'],
    CREDITCARD:                             ['creditcardHistoryReportComponent'],
    OPENRESERVATION:                        ['openReservationsReportComponent'],
    CANCELLEDRESERVATION:                   ['cancelledReservationReportComponent'],
    CLOSEDRESERVATION:                      ['closedReservationsReportComponent'],
    DEDUCTIONS:                             ['deductionsComponent'],
    VEHICLEJOBHISTORY:                      ['vehicleJobHistoryReportComponent'],
    ACCOUNTS:                               ['accountRidePaxReportComponent'],
    DAILYJOBCOUNT:                          ['dailyJobCountComponent'],
    RIDECLOSEOUTREPORT:                     ['ridesCloseoutReportComponent'],
    PREVIEWINVOICE:                         ['aRPreviewInvoiceReportComponent'],
    CHARTERINVOICE:                         ['billingCharterInvoiceReportComponent'],
    INVOICEPAID:                            ['invoicePaidReportCompnent'],
    DRIVERDUTYREPORT:                       ['driverDutyReportCompnent'],
};

// Order in which report type groups are displayed
const REPORT_TYPE_ORDER = ['BILLING', 'RESERVATION', 'DISPATCHING', 'FRANCHISEE', 'ACCOUNTS', 'ADMINISTRATION', 'MANAGEMENT'];

const REPORT_TYPE_ICONS = {
    BILLING:        'fas fa-coins',
    RESERVATION:    'fas fa-calendar-alt',
    DISPATCHING:    'fas fa-shipping-fast',
    FRANCHISEE:     'fas fa-city',
    ACCOUNTS:       'fas fa-chart-pie',
    ADMINISTRATION: 'fas fa-sliders-h',
    MANAGEMENT:     'fas fa-chart-line',
};

export class ReportComponent extends Component {
    static displayName = ReportComponent.name;

    constructor(props) {
        super(props);
        this.state = {
            loadPanelVisible: true,
            totalReports: [],
            searchValue: '',
            filteredReport: [],
            isReportDisplayList: true,
        }

        this.getReportList = this.getReportList.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.filterlist = this.filterlist.bind(this);
        this.handleReportEvent = this.handleReportEvent.bind(this);
        this.handleReportDisplay = this.handleReportDisplay.bind(this);
    }

    async componentDidMount() {
        await this.getReportList();
        this.setState({ loadPanelVisible: false });
    }

    handleInputChange(event) {
        const { name, type, value, checked } = event.target;
        const val = type === 'checkbox' ? checked : value;
        const source = val.trim() !== ''
            ? this.state.totalReports.filter(f => f.reportName.toUpperCase().includes(val.trim().toUpperCase()))
            : this.state.totalReports;
        this.setState({ [name]: val, filteredReport: this.filterlist(source) });
    }

    handleReportDisplay() {
        this.setState(prev => ({ isReportDisplayList: !prev.isReportDisplayList }));
    }

    clearSearch(e) {
        e.preventDefault();
        this.setState({
            searchValue: '',
            filteredReport: this.filterlist(this.state.totalReports)
        });
    }

    groupArrayOfObjects(list, key) {
        return list.reduce((rv, x) => {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    async getReportList() {
        try {
            const requestParams = getRequestParams('POST', { ActionTypeId: 1 });
            const response = await fetch('report-api/list', requestParams);
            const data = await response.json();
            this.setState({
                totalReports: data.reportList,
                filteredReport: this.filterlist(data.reportList)
            });
        } catch (e) {
            console.log(e);
        }
    }

    filterlist(datalist) {
        if (!datalist || datalist.length === 0) return [];
        const grouped = this.groupArrayOfObjects(datalist, 'reportType');
        return REPORT_TYPE_ORDER
            .filter(type => grouped[type] && grouped[type].length > 0)
            .map(type => ({
                reportTypeId: grouped[type][0].reportTypeId,
                reportType: grouped[type][0].reportType,
                reportList: grouped[type],
            }));
    }

    handleReportEvent(e, _reportName) {
        e.preventDefault();
        try {
            const key = _reportName
                .replace(/ +/g, '')
                .replace(/[:()\-/\[\]&]/g, '')
                .toUpperCase();

            if (REPORT_ROUTES[key]) {
                this.props.history.push({
                    pathname: REPORT_ROUTES[key],
                    state: { sourceUrl: '/report', sourceState: this.state }
                });
                return;
            }

            const action = REPORT_REF_ACTIONS[key];
            if (action) {
                const [refName, arg] = action;
                const ref = this.refs[refName];
                if (ref) ref.showModal(arg);
            }
        } catch (e) {
            // silently ignore
        }
    }

    render() {
        const { isReportDisplayList, filteredReport, totalReports, searchValue, loadPanelVisible } = this.state;
        return (
            <div className="content-wrapper rpt-wrapper">

                {/* ── Page Header ── */}
                <div className="rpt-header">
                    <div className="rpt-header-left">
                        <div className="rpt-header-icon"><i className="fas fa-chart-bar"></i></div>
                        <div>
                            <h4 className="rpt-title">Reports</h4>
                            <span className="rpt-subtitle">Browse and generate business reports</span>
                        </div>
                    </div>
                    <div className="rpt-header-right">
                        <div className="rpt-search-box">
                            <i className="fas fa-search rpt-search-icon"></i>
                            <input type="text" className="rpt-search-input" name="searchValue"
                                placeholder="Search reports..." maxLength="50"
                                value={searchValue} onChange={this.handleInputChange} />
                            {searchValue &&
                                <button className="rpt-search-clear" onClick={this.clearSearch}>
                                    <i className="fas fa-times"></i>
                                </button>
                            }
                        </div>
                        <div className="rpt-view-toggle">
                            <button className={`rpt-toggle-btn${!isReportDisplayList ? ' active' : ''}`}
                                title="Grid View" onClick={this.handleReportDisplay}>
                                <i className="fas fa-th"></i>
                            </button>
                            <button className={`rpt-toggle-btn${isReportDisplayList ? ' active' : ''}`}
                                title="List View" onClick={this.handleReportDisplay}>
                                <i className="fas fa-list"></i>
                            </button>
                        </div>
                    </div>
                </div>

                {/* ── Content ── */}
                <div className="rpt-content">

                    {/* Loading */}
                    {loadPanelVisible &&
                        <div className="rpt-loading">
                            <i className="fas fa-circle-notch fa-spin"></i>
                            <span>Loading reports...</span>
                        </div>
                    }

                    {/* Grid View */}
                    {!loadPanelVisible && !isReportDisplayList &&
                        <div className="rpt-grid-view">
                            <ul className="rpt-type-tabs" id="custom-tabs-tab" role="tablist">
                                <li>
                                    <a className="rpt-type-tab active" id="custom-tabs-all-tab" data-toggle="pill"
                                        href="#custom-tabs-all" role="tab" aria-selected="true">
                                        <i className="fas fa-border-all"></i> All
                                    </a>
                                </li>
                                {filteredReport.map((item, j) =>
                                    <li key={j}>
                                        <a className="rpt-type-tab"
                                            id={`custom-tabs-${item.reportType}-tab`}
                                            data-toggle="pill"
                                            href={`#custom-tabs-${item.reportType}`}
                                            role="tab" aria-selected="false">
                                            <i className={REPORT_TYPE_ICONS[item.reportType] || 'fas fa-file-alt'}></i> {item.reportType}
                                        </a>
                                    </li>
                                )}
                            </ul>
                            <div className="tab-content" id="custom-tabs-tabContent">
                                <div className="rpt-cards-grid tab-pane fade active show" id="custom-tabs-all" role="tabpanel">
                                    {totalReports.map((item, j) =>
                                        <div className={`rpt-card rpt-card-${item.reportType.toLowerCase()}`} key={j}
                                            onClick={(e) => this.handleReportEvent(e, item.reportName)}>
                                            <div className="rpt-card-icon">
                                                <i className={REPORT_TYPE_ICONS[item.reportType] || 'fas fa-file-alt'}></i>
                                            </div>
                                            <div className="rpt-card-body">
                                                <span className="rpt-card-type">{item.reportType}</span>
                                                <h6 className="rpt-card-name">{item.reportName}</h6>
                                            </div>
                                            <div className="rpt-card-arrow"><i className="fas fa-chevron-right"></i></div>
                                        </div>
                                    )}
                                </div>
                                {filteredReport.map((item, j) =>
                                    <div className="rpt-cards-grid tab-pane fade" key={j}
                                        id={`custom-tabs-${item.reportType}`} role="tabpanel">
                                        {item.reportList.map((tag, k) =>
                                            <div className={`rpt-card rpt-card-${item.reportType.toLowerCase()}`} key={k}
                                                onClick={(e) => this.handleReportEvent(e, tag.reportName)}>
                                                <div className="rpt-card-icon">
                                                    <i className={REPORT_TYPE_ICONS[item.reportType] || 'fas fa-file-alt'}></i>
                                                </div>
                                                <div className="rpt-card-body">
                                                    <span className="rpt-card-type">{item.reportType}</span>
                                                    <h6 className="rpt-card-name">{tag.reportName}</h6>
                                                </div>
                                                <div className="rpt-card-arrow"><i className="fas fa-chevron-right"></i></div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    }

                    {/* List View — empty */}
                    {!loadPanelVisible && isReportDisplayList && filteredReport.length === 0 &&
                        <div className="rpt-empty">
                            <i className="fas fa-search"></i>
                            <p>No reports found{searchValue ? ` for "${searchValue}"` : ''}.</p>
                        </div>
                    }

                    {/* List View — results */}
                    {!loadPanelVisible && isReportDisplayList && filteredReport.length > 0 &&
                        <div className="rpt-list-view">
                            {filteredReport.map((item, j) =>
                                <div className={`rpt-section rpt-section-${item.reportType.toLowerCase()}`} key={j}>
                                    <div className="rpt-section-header">
                                        <i className={REPORT_TYPE_ICONS[item.reportType] || 'fas fa-file-alt'}></i>
                                        <span>{item.reportType}</span>
                                        <span className="rpt-section-count">{item.reportList.length}</span>
                                    </div>
                                    <div className="rpt-section-body">
                                        {item.reportList.map((tag, k) =>
                                            <a href="#" className="rpt-list-item" key={k}
                                                onClick={(e) => this.handleReportEvent(e, tag.reportName)}>
                                                <i className="fas fa-file-alt rpt-list-item-icon"></i>
                                                <span>{tag.reportName}</span>
                                                <i className="fas fa-external-link-alt rpt-list-item-arrow"></i>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                </div>

                <VehiclePayReportPayrollPeriodwise ref="vehiclePayReportPayrollPeriodwise" />
                <IATAInvoiceReportComponent ref="iataInvoiceReportComponent" />
                <WorkCompensationReportComponent ref="workCompensationReportComponent" />
                <RideCommissionDetailsReportComponent ref="rideCommissionDetailsReportComponent" />
                <DriverLoginHistoryReportComponent ref="driverLoginHistoryReportComponent" />
                <CongestionReportComponent ref="congestionReportComponent" />
                <SalesActivityComponent ref="salesActivityComponent" />
                <VehiclePayReportSummaryDetailsComponent ref="vehiclePayReportSummaryDetailsComponent" />
                <InvoiceReportComponent ref="invoiceReportComponent" />
                <InvoiceSummaryReportPickupwiseComponent ref="invoiceSummaryReportPickupwiseComponent" />
                <InvoiceSummaryGraphComponent ref="invoiceSummaryGraphComponent" />
                <MonthlyBudgetComparisonReportComponent ref="monthlyBudgetComparisonReportComponent" />
                <DriverWorkHourHistoryReportComponent ref="driverWorkHourHistoryReportComponent" />
                <CustomerRideActivityReportComponent ref="customerRideActivityReportComponent" />
                <RevenueProfitLossComponent ref="revenueProfitLossComponent" />
                <RevenueYearlyComparisonComponent ref="revenueYearlyComparisonComponent" />
                <GTOnTimePerformanceComponent ref="gTOnTimePerformanceComponent" />
                <CompletedJobsComparisonReportComponent ref="completedJobsComparisonReportComponent" />
                <CumulativeSalesReportComponent ref="cumulativeSalesReportComponent" />
                <AirlineScorecardReportComponent ref="airlineScorecardReportComponent" />
                <AirlineRideActivityReportComponent ref="airlineRideActivityReportComponent" />
                <VehiclesProductivityReportComponent ref="vehiclesProductivityReportComponent" />
                <VehicleReimbursmentSummaryComponent ref="vehicleReimbursmentSummaryComponent" />
                <AgentCommissionReportComponent ref="agentCommissionReportComponent" />
                <AuditReportComponent ref="auditReportComponent" />
                <BillingReconsilationReportComponent ref="billingReconsilationReportComponent" />
                <VehicleCommissionReportComponent ref="vehicleCommissionReportComponent" />
                <VehicleDeductionReportComponent ref="vehicleDeductionReportComponent" />
                <VehicleDepositDetailsReportComponent ref="vehicleDepositDetailsReportComponent" />
                <VehicleLoanAccountLedgerComponent ref="vehicleLoanAccountLedgerComponent" />
                <VehicleLoanReportComponent ref="vehicleLoanReportComponent" />
                <VehicleReimbursmentAddOnsReportComponent ref="vehicleReimbursmentAddOnsReportComponent" />
                <VehicleReimbDeductionHistoryReportComponent ref="vehicleReimbDeductionHistoryReportComponent" />
                <VehicleReimbReceivableReportComponent ref="vehicleReimbReceivableReportComponent" />
                <VehicleReimbRevenueReportComponent ref="vehicleReimbRevenueReportComponent" />
                <FranchiseeDescripancyReportComponent ref="franchiseeDescripancyReportComponent" />
                <CustomerInvoiceSummaryReportComponent ref="customerInvoiceSummaryReportComponent" />
                <DataEntryAuditReportComponent ref="dataEntryAuditReportComponent" />
                <AccountPaymentsReportComponent ref="accountPaymentsReportComponent" />
                <RevenueSummaryGraphReportComponent ref="revenueSummaryGraphReportComponent" />
                <RideCommissionCashCCReportComponent ref="rideCommissionCashCCReportComponent" />
                <NoShowReservationReportComponent ref="noShowReservationReportComponent" />
                <AccountRideDetailsReportOnlyComponent ref="accountRideDetailsReportOnlyComponent" />
                <RideListingRevenueReportComponent ref="rideListingRevenueReportComponent" />
                <VehiclePayrollExceptionsComponent ref="vehiclePayrollExceptionsComponent" />
                <TaxComponent ref="taxComponent" />
                <DispatchComponent ref="dispatchComponent" />
                <MeetAndGreetReportComponent ref="meetAndGreetReportComponent" />
                <EstimateReimbursementReportComponent ref="estimateReimbursementReportComponent" />
                <AccountSummaryPaymentTypeWiseComponent ref="accountSummaryPaymentTypeWiseComponent" />
                <RideReconsilationReportComponent ref="rideReconsilationReportComponent" />
                <InvoiceDueSummaryReportComponent ref="invoiceDueSummaryReportComponent" />
                <RidesApprovedReportComponent ref="ridesApprovedReportComponent" />
                <RidesBilledReportComponent ref="ridesBilledReportComponent" />
                <RidesUnApprovedReportComponent ref="ridesUnApprovedReportComponent" />
                <CustomerCommissionRideReportComponent ref="customerCommissionRideReportComponent" />
                <RideListingCashCCReportComponent ref="rideListingCashCCReportComponent" />
                <RatesComponent ref="ratesComponent" />
                <DriverCommissionComponent ref="driverCommissionComponent" />
                <DriverPaidReportComponent ref="driverPaidReportComponent" />
                <DeductionsComponent ref="deductionsComponent" />
                <VehicleJobHistoryReportComponent ref="vehicleJobHistoryReportComponent" />
                <DeferredRevenueReportComponent ref="deferredRevenueReportComponent" />
                <CreditcardHistoryReportComponent ref="creditcardHistoryReportComponent" />
                <OpenReservationsReportComponent ref="openReservationsReportComponent" />
                <CancelledReservationsReportComponent ref="cancelledReservationReportComponent" />
                <ClosedReservationsReportComponent ref="closedReservationsReportComponent" />
                <AccountRidePaxReportComponent ref="accountRidePaxReportComponent" />
                <DailyJobCountComponent ref="dailyJobCountComponent" />
                <RidesCloseoutReportComponent ref="ridesCloseoutReportComponent" />
                <ARPreviewInvoiceReportComponent ref="aRPreviewInvoiceReportComponent" />
                <BillingCharterInvoiceReportComponent ref="billingCharterInvoiceReportComponent" />
                <InvoicePaidReportCompnent ref="invoicePaidReportCompnent" />
                <DriverDutyReportCompnent ref="driverDutyReportCompnent" />
            </div>
        );
    }
}
